<template>
  <div class="department-wrap style3 ptb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <Carousel
            :autoplay="5000"
            :wrap-around="true"
            :breakpoints="breakpoints"
            pause-autoplay-on-hover
            class="dp-img-slider"
          >
            <Slide v-for="image in images" :key="image.id">
              <div class="dp-img-item">
                <img :src="image.image" alt="Image" />
              </div>
            </Slide>

            <template #addons>
              <Pagination />
            </template>
          </Carousel>
        </div>

        <div class="col-lg-6">
          <div class="dp-content">
            <div class="content-title style3">
              <span>Our Department</span>
              <h2>
                Take Care Of You &amp; Your Family's Health &amp; Well-Being
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem has standard dummy text ever since the 1500s,
                when an unknown.
              </p>
            </div>

            <ul class="content-feature-list list-style">
              <li>
                <i class="ri-check-double-line"></i>Search for innovation in
                dentristy
              </li>
              <li>
                <i class="ri-check-double-line"></i>Flights, visa assistance
                &amp; transport facilities
              </li>
              <li>
                <i class="ri-check-double-line"></i>24/7 personal customer
                relationship manager
              </li>
              <li>
                <i class="ri-check-double-line"></i>Lifetime warrenties on all
                treatment services
              </li>
              <li>
                <i class="ri-check-double-line"></i>Advanced laser setup &amp;
                technology
              </li>
            </ul>

            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-clinic-1"></i>
                </div>
                <div class="feature-text">
                  <h5>
                    We've Short Stories About Clinic From Leading Plastic
                    Surgery Center
                  </h5>
                  <p>
                    It is a long established fact that reader will be distracted
                    by readable content sit amet consec tetur adiicing.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "OurDepartment",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    images: [
      {
        id: 1,
        image: require("../../assets/images/dp-img-3.jpg"),
      },
      {
        id: 2,
        image: require("../../assets/images/dp-img-4.jpg"),
      },
      {
        id: 3,
        image: require("../../assets/images/dp-img-5.jpg"),
      },
    ],
  }),
});
</script>